<template>
    <v-card>
        <v-card-title>
            {{ title }}
        </v-card-title>
        <v-card-text>
            {{ message }}
        </v-card-text>
        <v-row>
            <v-btn @click="$emit('onClick')">
            Accion de Prueba
            </v-btn>
            <v-btn @click="openModal">
                Open Another Modal
            </v-btn>
            <v-btn @click="$emit('close')">
                Close
            </v-btn>
        </v-row>
        
    </v-card>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Base Modal'
            },
            message : {
                type: String,
                default: 'This is a base modal component.'
            }
        },
        emits: ['onClick', 'close'],
        methods : {
            openModal(){
                this.$store.dispatch('openModal', {
                    component: 'PruebaModal',
                    props: {
                        title: 'Another Modal',
                        message: 'This is another modal opened from within a modal.'
                    },
                    events: {
                        close: () => {
                            console.log('Another modal closed');
                        }
                    }
                });
            }
        }
    }
</script>